export enum FieldEntityProtocol {
  MAXTIME_1 = 'MAXTIME_1',
  MAXTIME_2 = 'MAXTIME_2',
  MAXTIME_RAMPMETER_2 = 'MAXTIME_RAMPMETER_2',
  DYNAMIC = 'DYNAMIC',
  // Add other protocols as they are required
}
